module.exports = __webpack_public_path__ + "img/category_348.be4497ba.jpg";